import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { Community } from 'components/landing/shared/Community';
import { FAQ } from 'components/landing/shared/FAQ';

import { Ambassadors } from './Ambassadors';
import { Compete } from './Compete';
import { Footer } from './Footer';
import { HeroVideo } from './HeroVideo';
import { Leagues } from './Leagues';
import { Scout } from './Scout';
import { Win } from './Win';

const Root = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  overflow: hidden;
  position: relative;
  padding-bottom: var(--double-unit);
  @media ${tabletAndAbove} {
    gap: calc(8 * var(--unit));
  }
`;

const Hero = styled.div`
  @media ${tabletAndAbove} {
    margin-bottom: 100px;
  }
`;

const messages = defineMessages({
  metadatasTitle: {
    id: 'Football.Home.Public.meta.title',
    defaultMessage:
      'Play fantasy football with ownable digital player cards - Sorare',
  },
  metadatasDescription: {
    id: 'Football.Home.Public.meta.description',
    defaultMessage:
      "Play Sorare's free fantasy football game. Collect, buy, sell & compete with ownable digital player cards from the world's top leagues to win cash prizes.",
  },
});

type Props = {
  showFAQ?: boolean;
};
const EarlyAccess = ({ showFAQ }: Props) => {
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();

  useEffect(
    () =>
      setPageMetadata(formatMessage(messages.metadatasTitle), {
        img: 'https://frontend-assets.sorare.com/meta/social-picture-football-2023.jpg',
        description: formatMessage(messages.metadatasDescription),
      }),
    [setPageMetadata, formatMessage]
  );

  return (
    <Root>
      <Hero>
        <HeroVideo />
        <Leagues />
      </Hero>
      <Scout />
      <Compete />
      <Container>
        <Win />
      </Container>
      <Community />
      <Container>
        <Ambassadors />
      </Container>
      <Footer />
      {showFAQ && <FAQ />}
    </Root>
  );
};

export default EarlyAccess;
